import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-orte-list-view',
  imports: [],
  templateUrl: './orte.list-view.html',
  styleUrls: ['./orte.list-view.css'],
})
export class OrteListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
